import React, { useState, useEffect } from "react";
import axios from "axios";
import jwtDecode from "jwt-decode";
import { useNavigate } from "react-router-dom";
import "../../assets/css/adminStyle.css";
import Navbar from "./Navbar";

const Dashboard = () => {
  const [token, setToken] = useState("");
  const [exp, setExp] = useState("");
  const navigate = useNavigate();
  const [category, setCategory] = useState([]);
  const [categoryById, setCategoryById] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [intro, setIntro] = useState([]);
  const [introCaption, setIntroCaption] = useState("");
  const [introId, setIntroId] = useState("");
  const [user, setUser] = useState([]);
  const [userId, setUserId] = useState("");
  const [userName, setUserName] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [client, setClient] = useState([]);
  const [clientId, setClientId] = useState("");
  const [clientName, setClientName] = useState("");
  const [clientPhoto, setClientPhoto] = useState("");
  const [service, setService] = useState([]);
  const [serviceId, setServiceId] = useState("");
  const [serviceName, setServiceName] = useState("");
  const [serviceCaption, setServiceCaption] = useState("");
  const [servicePhoto, setServicePhoto] = useState("");
  const [about, setAbout] = useState([]);
  const [aboutId, setAboutId] = useState("");
  const [aboutCaption, setAboutCaption] = useState("");
  const [aboutPhoto, setAboutPhoto] = useState("");
  const [display, setDisplay] = useState([]);
  const [displayId, setDisplayId] = useState("");
  const [displayPhoto, setDisplayPhoto] = useState("");
  const [displayCategory, setDisplayCategory] = useState("");
  const [product, setProduct] = useState([]);
  const [productId, setProductId] = useState("");
  const [productName, setProductName] = useState("");
  const [productCategory, setProductCategory] = useState("");
  const [productPhoto, setProductPhoto] = useState("");
  const [contact, setContact] = useState([]);
  const [contactId, setContactId] = useState("");
  const [contactName, setContactName] = useState("");
  const [contactSocmed, setContactSocmed] = useState("");
  const [contactNoHp, setContactNoHp] = useState("");
  const [header, setHeader] = useState([]);
  const [headerPhoto, setHeaderPhoto] = useState("");
  const [headerId, setHeaderId] = useState("");
  const [download, setDownload] = useState([]);
  const [downloadId, setDownloadId] = useState("");
  const [downloadName, setDownloadName] = useState("");
  const [downloadUrl, setDownloadUrl] = useState("");

  useEffect(() => {
    refreshToken();
    getCategory();
    getIntroCaption();
    getAllUsers();
    getAllClients();
    getAllServices();
    getAllAbout();
    getAllDisplays();
    getAllProducts();
    getAllContacts();
    getAllHeaders();
    getAllDownloads();
  }, []);

  const axiosJWT = axios.create();

  // axios interceptor berfungsi untuk melakukan pengecekan sebelum  request
  axiosJWT.interceptors.request.use(
    async (config) => {
      const currentDate = new Date();
      if (exp * 1000 < currentDate.getTime()) {
        const response = await axios.get(
          `${process.env.REACT_APP_SERVER}users/token`
        );
        config.headers.Authorization = `Bearer ${response.data.accessToken}`;
        setToken(response.data.accessToken);
        const decoded = jwtDecode(response.data.accessToken);
        setExp(decoded.exp);
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  const Logout = async () => {
    try {
      await axios.delete(`${process.env.REACT_APP_SERVER}users/logout`);
      navigate("/login");
    } catch (error) {
      // console.log(error);
    }
  };

  const refreshToken = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}users/token`
      );
      setToken(response.data.accessToken);
      const decoded = jwtDecode(response.data.accessToken);
      setExp(decoded.exp);
    } catch (error) {
      if (error.response) {
        navigate("/login");
      }
    }
  };

  const getCategory = async () => {
    try {
      const response = await axiosJWT.get(
        `${process.env.REACT_APP_SERVER}categories`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setCategory(response.data.categories);
    } catch (error) {
      console.log(error);
    }
  };

  const getCategoryById = async (categoryId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}categories/${categoryId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCategoryById(response.data.categories[0].name);
      setCategoryId(response.data.categories[0].id);
      document.getElementById("ubah-kategori").classList.toggle("hidden");
    } catch (error) {
      console.log(error);
    }
  };

  const createCategory = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", categoryName);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}categories`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert(response.data.msg);
      window.location.reload();
    } catch (error) {
      console.log(error);
      if (error.response) {
        alert(error.response.data.msg);
        window.location.reload();
      }
    }
  };

  const updateCategory = async (e) => {
    e.preventDefault();
    console.log(categoryName);
    const formData = new FormData();
    formData.append("name", categoryById);
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_SERVER}categories/${categoryId}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert(response.data.msg);
      window.location.reload();
    } catch (error) {
      console.log(error);
      if (error.response) {
        alert(error.response.data.msg);
        console.log(error);
        window.location.reload();
      }
    }
  };

  const deleteCategory = async (categoryId) => {
    try {
      const confirm = window.confirm("Apakah anda yakin ?");
      if (confirm) {
        const response = await axios.delete(
          `${process.env.REACT_APP_SERVER}categories/${categoryId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        alert(response.data.msg);
        window.location.reload();
      }
    } catch (error) {
      if (error.response) {
        alert(error.response.data.msg);
        window.location.reload();
      }
      console.log(error);
    }
  };

  const getIntroCaption = async () => {
    try {
      const response = await axiosJWT.get(
        `${process.env.REACT_APP_SERVER}introCaption`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setIntro(response.data.intro);
    } catch (error) {
      // console.log(error);
    }
  };

  const getIntroCaptionById = async (introId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}introCaption/${categoryId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setIntroCaption(response.data.intro[0].caption);
      setIntroId(response.data.intro[0].id);
      document.getElementById("ubah-intro").classList.toggle("hidden");
    } catch (error) {
      console.log(error);
    }
  };

  const updateIntro = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("caption", introCaption);
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_SERVER}introCaption/${introId}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert(response.data.msg);
      window.location.reload();
    } catch (error) {
      console.log(error);
      if (error.response) {
        alert(error.response.data.msg);
        console.log(error);
        window.location.reload();
      }
    }
  };

  const getAllUsers = async (e) => {
    try {
      const response = await axiosJWT.get(
        `${process.env.REACT_APP_SERVER}users`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setUser(response.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const getUserById = async (userId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}users/${userId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setUsername(response.data.user[0].username);
      setUserName(response.data.user[0].name);
      setUserId(response.data.user[0].id);
      document.getElementById("ubah-admin").classList.toggle("hidden");
    } catch (error) {
      console.log(error);
    }
  };

  const createUser = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("username", username);
    formData.append("name", userName);
    formData.append("password", password);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}users`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert(response.data.msg);
      window.location.reload();
    } catch (error) {
      console.log(error);
      if (error.response) {
        alert(error.response.data.msg);
        window.location.reload();
      }
    }
  };

  const updateUser = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("username", username);
    formData.append("name", userName);
    formData.append("password", password);
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_SERVER}users/${userId}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert(response.data.msg);
      window.location.reload();
    } catch (error) {
      console.log(error);
      if (error.response) {
        alert(error.response.data.msg);
        window.location.reload();
      }
    }
  };

  const deleteUser = async (userId) => {
    try {
      const confirm = window.confirm("Apakah anda yakin ?");
      if (confirm) {
        const response = await axios.delete(
          `${process.env.REACT_APP_SERVER}users/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        alert(response.data.msg);
        window.location.reload();
      }
    } catch (error) {
      if (error.response) {
        alert(error.response.data.msg);
        window.location.reload();
      }
      console.log(error);
    }
  };

  const getAllClients = async (e) => {
    try {
      const response = await axiosJWT.get(
        `${process.env.REACT_APP_SERVER}client`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setClient(response.data.clients);
    } catch (error) {
      // console.log(error);
    }
  };

  const getClientById = async (clientId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}client/${clientId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setClientId(response.data.client[0].id);
      setClientName(response.data.client[0].name);
      console.log(response);
      document.getElementById("ubah-klien").classList.toggle("hidden");
    } catch (error) {
      console.log(error);
    }
  };

  const createClient = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", clientName);
    formData.append("photo", clientPhoto);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}client`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert(response.data.msg);
      window.location.reload();
    } catch (error) {
      console.log(error);
      if (error.response) {
        alert(error.response.data.msg);
        window.location.reload();
      }
    }
  };

  const updateClient = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", clientName);
    formData.append("photo", clientPhoto);
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_SERVER}client/${clientId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert(response.data.msg);
      window.location.reload();
    } catch (error) {
      console.log(error);
      if (error.response) {
        alert(error.response.data.msg);
        window.location.reload();
      }
    }
  };

  const deleteClient = async (clientId) => {
    try {
      const confirm = window.confirm("Apakah anda yakin ?");
      if (confirm) {
        const response = await axios.delete(
          `${process.env.REACT_APP_SERVER}client/${clientId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        alert(response.data.msg);
        window.location.reload();
      }
    } catch (error) {
      if (error.response) {
        alert(error.response.data.msg);
        window.location.reload();
      }
      console.log(error);
    }
  };

  const createService = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", serviceName);
    formData.append("caption", serviceCaption);
    formData.append("photo", servicePhoto);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}service`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert(response.data.msg);
      window.location.reload();
    } catch (error) {
      console.log(error);
      if (error.response) {
        alert(error.response.data.msg);
        window.location.reload();
      }
    }
  };

  const getAllServices = async (e) => {
    try {
      const response = await axiosJWT.get(
        `${process.env.REACT_APP_SERVER}service`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setService(response.data.service);
    } catch (error) {
      // console.log(error);
    }
  };

  const getServiceById = async (serviceId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}service/${serviceId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setServiceId(response.data.service[0].id);
      setServiceName(response.data.service[0].name);
      setServiceCaption(response.data.service[0].caption);
      // console.log(response);
      document.getElementById("ubah-servis").classList.toggle("hidden");
    } catch (error) {
      console.log(error);
    }
  };

  const updateService = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", serviceName);
    formData.append("caption", serviceCaption);
    formData.append("photo", servicePhoto);
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_SERVER}service/${serviceId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert(response.data.msg);
      window.location.reload();
    } catch (error) {
      console.log(error);
      if (error.response) {
        alert(error.response.data.msg);
        window.location.reload();
      }
    }
  };

  const deleteService = async (serviceId) => {
    try {
      const confirm = window.confirm("Apakah anda yakin ?");
      if (confirm) {
        const response = await axios.delete(
          `${process.env.REACT_APP_SERVER}service/${serviceId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        alert(response.data.msg);
        window.location.reload();
      }
    } catch (error) {
      if (error.response) {
        alert(error.response.data.msg);
        window.location.reload();
      }
      console.log(error);
    }
  };

  const getAllAbout = async (e) => {
    try {
      const response = await axiosJWT.get(
        `${process.env.REACT_APP_SERVER}aboutUs`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setAbout(response.data.about);
    } catch (error) {
      // console.log(error);
    }
  };

  const getAboutById = async (aboutId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}aboutUs/${aboutId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setAboutId(response.data.about[0].id);
      setAboutCaption(response.data.about[0].caption);
      document.getElementById("ubah-tentang-kami").classList.toggle("hidden");
    } catch (error) {
      console.log(error);
    }
  };

  const updateAbout = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("caption", aboutCaption);
    formData.append("photo", aboutPhoto);
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_SERVER}aboutUs/${aboutId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert(response.data.msg);
      window.location.reload();
    } catch (error) {
      console.log(error);
      if (error.response) {
        alert(error.response.data.msg);
        window.location.reload();
      }
    }
  };

  const getAllDisplays = async (e) => {
    try {
      const response = await axiosJWT.get(
        `${process.env.REACT_APP_SERVER}categoryDisplay`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log(response);
      setDisplay(response.data.categoryDisplays);
    } catch (error) {
      console.log(error);
    }
  };

  const createDisplay = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("CategoryId", displayCategory);
    formData.append("photo", displayPhoto);
    try {
      const response = await axios.post(
        `process.env.REACT_APP_SERVER}categoryDisplay`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert(response.data.msg);
      window.location.reload();
    } catch (error) {
      console.log(error);
      if (error.response) {
        alert(error.response.data.msg);
        window.location.reload();
      }
    }
  };

  const getDisplayById = async (displayId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}categoryDisplay/${displayId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setDisplayCategory(response.data.categoryDisplay[0].CategoryId);
      setDisplayId(response.data.categoryDisplay[0].id);
      document.getElementById("ubah-display").classList.toggle("hidden");
    } catch (error) {
      console.log(error);
    }
  };

  const updateDisplay = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("CategoryId", displayCategory);
    formData.append("photo", displayPhoto);
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_SERVER}categoryDisplay/${displayId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response);
      alert(response.data.msg);
      window.location.reload();
    } catch (error) {
      console.log(error);
      if (error.response) {
        alert(error.response.data.msg);
        window.location.reload();
      }
    }
  };

  const deleteDisplay = async (displayId) => {
    try {
      const confirm = window.confirm("Apakah anda yakin ?");
      if (confirm) {
        const response = await axios.delete(
          `${process.env.REACT_APP_SERVER}categoryDisplay/${displayId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        alert(response.data.msg);
        window.location.reload();
      }
    } catch (error) {
      if (error.response) {
        alert(error.response.data.msg);
        window.location.reload();
      }
      console.log(error);
    }
  };

  const getAllProducts = async (e) => {
    try {
      const response = await axiosJWT.get(
        `${process.env.REACT_APP_SERVER}product`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log(response);
      setProduct(response.data.products);
    } catch (error) {
      // console.log(error);
    }
  };

  const createProduct = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", productName);
    formData.append("CategoryId", productCategory);
    formData.append("photo", productPhoto);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}product`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert(response.data.msg);
      window.location.reload();
    } catch (error) {
      console.log(error);
      if (error.response) {
        alert(error.response.data.msg);
        window.location.reload();
      }
    }
  };

  const deleteProduct = async (productId) => {
    try {
      const confirm = window.confirm("Apakah anda yakin ?");
      if (confirm) {
        const response = await axios.delete(
          `${process.env.REACT_APP_SERVER}product/${productId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        alert(response.data.msg);
        window.location.reload();
      }
    } catch (error) {
      if (error.response) {
        alert(error.response.data.msg);
        window.location.reload();
      }
      console.log(error);
    }
  };

  const getProductById = async (productId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}product/${productId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setProductId(response.data.product[0].id);
      setProductCategory(response.data.product[0].CategoryId);
      setProductName(response.data.product[0].name);
      document.getElementById("ubah-produk").classList.toggle("hidden");
    } catch (error) {
      console.log(error);
    }
  };

  const updateProduct = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", productName);
    formData.append("CategoryId", productCategory);
    formData.append("photo", productPhoto);
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_SERVER}product/${productId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response);
      alert(response.data.msg);
      window.location.reload();
    } catch (error) {
      console.log(error);
      if (error.response) {
        alert(error.response.data.msg);
        window.location.reload();
      }
    }
  };

  const getAllContacts = async (e) => {
    try {
      const response = await axiosJWT.get(
        `${process.env.REACT_APP_SERVER}contact`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setContact(response.data.contacts);
    } catch (error) {
      // console.log(error);
    }
  };

  const createContact = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", contactName);
    formData.append("socmed", contactSocmed);
    formData.append("noHP", contactNoHp);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}contact`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert(response.data.msg);
      window.location.reload();
    } catch (error) {
      console.log(error);
      if (error.response) {
        alert(error.response.data.msg);
        window.location.reload();
      }
    }
  };

  const deleteContact = async (contactId) => {
    try {
      const confirm = window.confirm("Apakah anda yakin ?");
      if (confirm) {
        const response = await axios.delete(
          `${process.env.REACT_APP_SERVER}contact/${contactId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        alert(response.data.msg);
        window.location.reload();
      }
    } catch (error) {
      if (error.response) {
        alert(error.response.data.msg);
        window.location.reload();
      }
      console.log(error);
    }
  };

  const getContactById = async (contactId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}contact/${contactId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setContactName(response.data.contact[0].name);
      setContactNoHp(response.data.contact[0].noHP);
      setContactSocmed(response.data.contact[0].socmed);
      setContactId(response.data.contact[0].id);
      document.getElementById("ubah-kontak").classList.toggle("hidden");
    } catch (error) {
      console.log(error);
    }
  };

  const updateContact = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", contactName);
    formData.append("socmed", contactSocmed);
    formData.append("noHP", contactNoHp);
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_SERVER}contact/${contactId}`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert(response.data.msg);
      window.location.reload();
    } catch (error) {
      console.log(error);
      if (error.response) {
        alert(error.response.data.msg);
        window.location.reload();
      }
    }
  };

  const getAllHeaders = async (e) => {
    try {
      const response = await axiosJWT.get(
        `${process.env.REACT_APP_SERVER}header`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setHeader(response.data.header);
    } catch (error) {
      // console.log(error);
    }
  };

  const getHeaderById = async (headerId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}header/${headerId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setHeaderPhoto(response.data.header[0].url);
      setHeaderId(response.data.header[0].id);
      document.getElementById("ubah-header").classList.toggle("hidden");
    } catch (error) {
      console.log(error);
    }
  };

  const updateHeader = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("photo", headerPhoto);
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_SERVER}header/${headerId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert(response.data.msg);
      window.location.reload();
    } catch (error) {
      console.log(error);
      if (error.response) {
        alert(error.response.data.msg);
        window.location.reload();
      }
    }
  };

  const getAllDownloads = async (e) => {
    try {
      const response = await axiosJWT.get(
        `${process.env.REACT_APP_SERVER}download`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setDownload(response.data.downloads);
    } catch (error) {
      console.log(error);
    }
  };

  const getDownloadById = async (downloadId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}download/${downloadId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setDownloadId(response.data.download[0].id);
      setDownloadName(response.data.download[0].name);
      setDownloadUrl(response.data.download[0].url);
      document.getElementById("ubah-download").classList.toggle("hidden");
    } catch (error) {
      console.log(error);
    }
  };

  const createDownload = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", downloadName);
    formData.append("url", downloadUrl);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}download`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert(response.data.msg);
      window.location.reload();
    } catch (error) {
      console.log(error);
      if (error.response) {
        alert(error.response.data.msg);
        window.location.reload();
      }
    }
  };

  const deleteDownload = async (downloadId) => {
    try {
      const confirm = window.confirm("Apakah anda yakin ?");
      if (confirm) {
        const response = await axios.delete(
          `${process.env.REACT_APP_SERVER}download/${downloadId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        alert(response.data.msg);
        window.location.reload();
      }
    } catch (error) {
      if (error.response) {
        alert(error.response.data.msg);
        window.location.reload();
      }
      console.log(error);
    }
  };

  const updateDownload = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", downloadName);
    formData.append("url", downloadUrl);
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_SERVER}download/${downloadId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      alert(response.data.msg);
      window.location.reload();
    } catch (error) {
      console.log(error);
      if (error.response) {
        alert(error.response.data.msg);
        window.location.reload();
      }
    }
  };

  return (
    <>
      <Navbar Logout={Logout} />
      <div className="w-full py-20 bg-[#f1f1f1] font-poppins relative">
        <div className="container mx-auto">
          <div className="w-full flex gap-5 md:gap-0 flex-wrap justify-center  md:justify-around">
            <div className="md:flex md:gap-7 md:mt-4 md:flex-wrap mx-auto">
              <div className="w-[90vw]  md:w-[45vw] h-[300px] overflow-hidden  bg-white mt-2 drop-shadow-lg p-4 rounded-xl mx-auto">
                <div className="flex justify-between border-b-2 pb-1 items-center">
                  <div>
                    <h3 className="uppercase text-lg text-slate-500">
                      Kategori
                    </h3>
                  </div>
                  <button
                    className="block text-green-600 hover:text-blue-500 focus:ring-4 focus:outline-none  font-medium rounded-lg text-sm text-center "
                    type="button"
                    onClick={() =>
                      document
                        .getElementById("tambah-kategori")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-plus-circle fa fa-plus-circle text-xl "
                      aria-hidden="true"
                    ></i>
                  </button>
                </div>
                <div className="w-full h-full pb-8 overflow-auto">
                  <table className="table-auto w-full border-collapse mt-4">
                    <thead>
                      <tr className="text-sm">
                        <th className="border py-2">No</th>
                        <th className="border">Nama</th>
                        <th className="border">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {category.map((ctgr, i) => (
                        <tr key={ctgr.id} className="text-center text-sm">
                          <td className="border p-2">{i + 1}</td>
                          <td className="border px-10">{ctgr.name}</td>
                          <td className="border">
                            <button
                              className="px-3 py-1 bg-blue-600 text-white"
                              onClick={() =>
                                // document
                                //   .getElementById("ubah-kategori")
                                //   .classList.toggle("hidden")
                                getCategoryById(`${ctgr.id}`)
                              }
                            >
                              <i
                                className="fa fa-pencil"
                                aria-hidden="true"
                              ></i>
                            </button>
                            <a
                              onClick={() => deleteCategory(ctgr.id)}
                              className="px-3 py-1 bg-red-500 ml-2 text-white cursor-pointer"
                            >
                              <i className="fa fa-trash" aria-hidden="true"></i>
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="w-[90vw]  md:w-[45vw] h-[300px] overflow-y-hidden overflow-x-auto  bg-white md:mt-2 mt-8 drop-shadow-lg p-4 rounded-xl">
                <div className="flex justify-between border-b-2 pb-1 items-center">
                  <div>
                    <h3 className="uppercase text-lg text-slate-500">Klien</h3>
                  </div>
                  <button
                    className="hover:text-emerald-900"
                    onClick={() =>
                      document
                        .getElementById("tambah-klien")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-plus-circle text-xl text-green-600"
                      aria-hidden="true"
                    ></i>
                  </button>
                </div>
                <div className="w-full h-full pb-8 overflow-auto">
                  <table className="table-auto w-full border-collapse mt-4">
                    <thead>
                      <tr className="text-sm">
                        <th className="border p-2">No</th>
                        <th className="border p-2 hidden md:block">Logo</th>
                        <th className="border">Nama</th>
                        <th className="border">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {client.map((cl, index) => (
                        <tr key={cl.id} className="text-center text-sm">
                          <td className="border p-2">{index + 1}</td>
                          <td className="border px-10 p-2 hidden md:block">
                            <img src={cl.url} className="w-[120px] h-[50px]" />
                          </td>
                          <td className="border px-10">{cl.name}</td>
                          <td className="border">
                            <div className="flex px-2 justify-center">
                              <button
                                className="px-3 py-1 bg-blue-600 text-white"
                                onClick={() => getClientById(`${cl.id}`)}
                              >
                                <i className="fa fa-pencil"></i>
                              </button>
                              <a
                                onClick={() => deleteClient(`${cl.id}`)}
                                className="px-3 py-1 bg-red-500 ml-2 text-white cursor-pointer"
                              >
                                <i
                                  className="fa fa-trash"
                                  aria-hidden="true"
                                ></i>
                              </a>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="w-[90vw]  md:w-[45vw] h-[300px] overflow-hidden  bg-white md:mt-2 mt-8 drop-shadow-lg p-4 rounded-xl mx-auto ">
                <div className="flex justify-between border-b-2 pb-1 items-center">
                  <div>
                    <h3 className="uppercase text-lg text-slate-500">Servis</h3>
                  </div>
                  <button
                    className="hover:text-emerald-900"
                    onClick={() =>
                      document
                        .getElementById("tambah-servis")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-plus-circle text-xl text-green-600"
                      aria-hidden="true"
                    ></i>
                  </button>
                </div>
                <div className="w-full h-full pb-8 overflow-auto">
                  <table className="table-auto w-full border-collapse mt-4">
                    <thead>
                      <tr className="text-sm">
                        <th className="border p-2 hidden md:block">Ikon</th>
                        <th className="border p-2">Nama</th>
                        <th className="border p-2">Keterangan</th>
                        <th className="border p-2">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {service.map((srv, i) => (
                        <tr key={srv.id} className="text-center text-sm">
                          <td className="border p-2 hidden   md:flex">
                            <img
                              src={srv.url}
                              className="w-[120px] h-[50px] mx-auto"
                            />
                          </td>
                          <td className="border px-10 p-2">{srv.name}</td>
                          <td className="border text-[9px]">{srv.caption}</td>
                          <td className="border">
                            <div className="flex px-2">
                              <button
                                className="px-3 py-1 bg-blue-600 text-white"
                                onClick={() =>
                                  // document
                                  //   .getElementById("ubah-servis")
                                  //   .classList.toggle("hidden")
                                  getServiceById(`${srv.id}`)
                                }
                              >
                                <i className="fa fa-pencil"></i>
                              </button>
                              <a
                                onClick={() => deleteService(`${srv.id}`)}
                                className="px-3 py-1 bg-red-500 ml-2 text-white cursor-pointer"
                              >
                                <i
                                  className="fa fa-trash"
                                  aria-hidden="true"
                                ></i>
                              </a>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="w-[90vw]  md:w-[45vw] h-[300px] overflow-y-hidden overflow-x-auto  bg-white md:mt-2 mt-8 drop-shadow-lg p-4 rounded-xl">
                <div className="flex justify-between border-b-2 pb-1 items-center">
                  <div>
                    <h3 className="uppercase text-lg text-slate-500">
                      Teks Pembuka
                    </h3>
                  </div>
                </div>
                <div className="w-full h-full pb-8 overflow-auto">
                  <table className="table-auto w-full border-collapse mt-4">
                    <thead>
                      <tr className="text-sm">
                        <th className="border p-2">No</th>
                        <th className="border">Teks</th>
                        <th className="border">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {intro.map((intr, index) => (
                        <tr key={intr.id} className="text-center text-sm">
                          <td className="border p-2">{index + 1}</td>

                          <td className="border px-10 text-[10px]">
                            {intr.caption}
                          </td>
                          <td className="border px-2">
                            <button
                              href=""
                              className="px-3 py-1 bg-blue-600 text-white"
                              onClick={() => getIntroCaptionById(`${intr.id}`)}
                            >
                              <i
                                className="fa fa-pencil"
                                aria-hidden="true"
                              ></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full flex gap-5 md:gap-0 flex-wrap justify-center  md:justify-around mt-6 md:mt-2">
            <div className=" w-full md:flex md:gap-7 md:mt-4 md:flex-wrap mx-auto md:justify-between ">
              <div className="w-[90vw]  md:w-[45vw] h-[300px] overflow-hidden  bg-white mt-2 drop-shadow-lg p-4 rounded-xl mx-auto ">
                <div className="flex justify-between border-b-2 pb-1 items-center">
                  <div>
                    <h3 className="uppercase text-lg text-slate-500">
                      Tentang Kami
                    </h3>
                  </div>
                </div>
                <div className="w-full h-full pb-8 overflow-auto">
                  <table className="table-auto w-full border-collapse mt-4 ">
                    <thead>
                      <tr className="text-sm">
                        <th className="border p-3 hidden md:block">Ikon</th>
                        <th className="border p-3">Keterangan</th>
                        <th className="border p-3 ">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {about.map((abt, index) => (
                        <tr key={abt.id} className="text-center text-sm">
                          <td className="border p-2  h-full hidden md:inline-block">
                            <img
                              src={abt.url}
                              className="w-[120px] h-[100px] mx-auto"
                            />
                          </td>
                          <td className="border text-[9px] p-2">
                            {abt.caption}
                          </td>
                          <td className="border p-2  h-full">
                            <div className="w-full flex justify-center">
                              <button
                                className="px-3 py-1 bg-blue-600 text-white"
                                onClick={() =>
                                  // document
                                  //   .getElementById("ubah-tentang-kami")
                                  //   .classList.toggle("hidden")
                                  getAboutById(`${abt.id}`)
                                }
                              >
                                <i className="fa fa-pencil"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="w-[90vw]  md:w-[45vw] h-[300px] overflow-y-hidden overflow-x-auto  bg-white md:mt-2 mt-8 drop-shadow-lg p-4 rounded-xl mx-auto">
                <div className="flex justify-between border-b-2 pb-1 items-center">
                  <div>
                    <h3 className="uppercase text-lg text-slate-500">
                      TOP 4 Categories
                    </h3>
                  </div>
                  {/* <button
                    className="hover:text-emerald-900"
                    onClick={() =>
                      document
                        .getElementById("tambah-display")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-plus-circle text-xl text-green-600"
                      aria-hidden="true"
                    ></i>
                  </button> */}
                </div>
                <div className="w-full h-full pb-8 overflow-auto">
                  <table className="table-auto w-full border-collapse mt-4">
                    <thead>
                      <tr className="text-sm">
                        <th className="border p-2">No</th>
                        <th className="border p-2 hidden md:block">Gambar</th>
                        <th className="border">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {display.map((dsp, index) => (
                        <tr key={dsp.id} className="text-center text-sm">
                          <td className="border p-2">{index + 1}</td>
                          <td className=" px-10 border p-2 hidden md:flex">
                            <img
                              src={dsp.url}
                              className="w-[120px] h-[50px] md:mx-auto"
                            />
                          </td>
                          <td className="border">
                            <button
                              className="px-3 py-1 bg-blue-600 text-white"
                              onClick={() =>
                                // document
                                //   .getElementById("ubah-top-4")
                                //   .classList.toggle("hidden")
                                getDisplayById(`${dsp.id}`)
                              }
                            >
                              <i
                                className="fa fa-pencil"
                                aria-hidden="true"
                              ></i>
                            </button>
                            {/* <a
                              onClick={() => deleteDisplay(`${dsp.id}`)}
                              className="px-3 py-1 bg-red-500 ml-2 text-white cursor-pointer"
                            >
                              <i className="fa fa-trash" aria-hidden="true"></i>
                            </a> */}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="w-[90vw]  md:w-[45vw] h-[300px] overflow-y-hidden overflow-x-auto  bg-white md:mt-2 mt-8 drop-shadow-lg p-4 rounded-xl mx-auto">
                <div className="flex justify-between border-b-2 pb-1 items-center">
                  <div>
                    <h3 className="uppercase text-lg text-slate-500">Produk</h3>
                  </div>
                  <button
                    className="hover:text-emerald-900"
                    onClick={() =>
                      document
                        .getElementById("tambah-produk")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-plus-circle text-xl text-green-600"
                      aria-hidden="true"
                    ></i>
                  </button>
                </div>
                <div className="w-full h-full pb-8 overflow-auto">
                  <table className="table-auto w-full border-collapse mt-4">
                    <thead>
                      <tr className="text-sm">
                        <th className="border p-2">No</th>
                        <th className="border p-2 hidden md:block">Gambar</th>
                        {/* <th className="border">Kategori</th> */}
                        <th className="border">Nama</th>
                        <th className="border">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {product.map((prd, i) => (
                        <tr key={prd.id} className="text-center text-sm">
                          <td className="border p-2">{i + 1}</td>
                          <td className=" px-10 p-2 hidden md:flex border">
                            <img
                              src={prd.url}
                              className="w-[120px] h-[50px] md:mx-auto"
                            />
                          </td>
                          <td className="border px-10">{prd.name}</td>
                          {/* <td className="border px-10">Indofood</td> */}
                          <td className="border">
                            <div className="flex px-2">
                              <button
                                className="px-3 py-1 bg-blue-600 text-white"
                                onClick={() => getProductById(`${prd.id}`)}
                              >
                                <i
                                  className="fa fa-pencil"
                                  aria-hidden="true"
                                ></i>
                              </button>
                              <a
                                onClick={() => deleteProduct(`${prd.id}`)}
                                className="px-3 py-1 bg-red-500 ml-2 text-white cursor-pointer"
                              >
                                <i
                                  className="fa fa-trash"
                                  aria-hidden="true"
                                ></i>
                              </a>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="w-[90vw]  md:w-[45vw] h-[300px] overflow-y-hidden overflow-x-auto  bg-white md:mt-2 mt-8 drop-shadow-lg p-4 rounded-xl mx-auto">
                <div className="flex justify-between border-b-2 pb-1 items-center">
                  <div>
                    <h3 className="uppercase text-lg text-slate-500">ADMIN</h3>
                  </div>
                  <button
                    className="hover:text-emerald-900"
                    onClick={() =>
                      document
                        .getElementById("tambah-admin")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-plus-circle text-xl text-green-600"
                      aria-hidden="true"
                    ></i>
                  </button>
                </div>
                <div className="w-full h-full pb-8 overflow-auto">
                  <table className="table-auto w-full border-collapse mt-4">
                    <thead>
                      <tr className="text-sm">
                        <th className="border p-2">No</th>
                        <th className="border p-2 ">Nama</th>
                        <th className="border">Username</th>
                        <th className="border">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {user.map((usr, index) => (
                        <tr key={usr.id} className="text-center text-sm">
                          <td className="border p-2">{index + 1}</td>
                          <td className="border px-10">{usr.name}</td>
                          <td className="border px-10">{usr.username}</td>
                          <td className="border">
                            <div className="flex px-2 justify-center">
                              <button
                                onClick={() =>
                                  // document
                                  //   .getElementById("ubah-admin")
                                  //   .classList.toggle("hidden")
                                  getUserById(`${usr.id}`)
                                }
                                className="px-3 py-1 bg-blue-600 text-white"
                              >
                                <i
                                  className="fa fa-pencil"
                                  aria-hidden="true"
                                ></i>
                              </button>
                              <a
                                onClick={() => deleteUser(`${usr.id}`)}
                                className="px-3 py-1 bg-red-500 ml-2 text-white cursor-pointer"
                              >
                                <i
                                  className="fa fa-trash"
                                  aria-hidden="true"
                                ></i>
                              </a>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="w-[90vw]  md:w-[45vw] h-[300px] overflow-y-hidden overflow-x-auto  bg-white md:mt-2 mt-8 drop-shadow-lg p-4 rounded-xl mx-auto">
                <div className="flex justify-between border-b-2 pb-1 items-center">
                  <div>
                    <h3 className="uppercase text-lg text-slate-500">
                      Gambar Utama
                    </h3>
                  </div>
                  {/* <button
                    className="hover:text-emerald-900"
                    onClick={() =>
                      document
                        .getElementById("tambah-produk")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-plus-circle text-xl text-green-600"
                      aria-hidden="true"
                    ></i>
                  </button> */}
                </div>
                <div className="w-full h-full pb-8 overflow-auto">
                  <table className="table-auto w-full border-collapse mt-4">
                    <thead>
                      <tr className="text-sm">
                        <th className="border p-2">No</th>
                        <th className="border p-2 ">Gambar</th>
                        <th className="border p-2 ">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {header.map((head, i) => (
                        <tr key={head.id} className="text-center text-sm">
                          <td className="border p-2">{i + 1}</td>
                          <td className=" px-10 p-2 md:flex border">
                            <img
                              src={head.url}
                              className="w-[120px] h-[50px] md:mx-auto"
                            />
                          </td>
                          <td className="border">
                            <div className="flex px-2 justify-center">
                              <button
                                className="px-3 py-1 bg-blue-600 text-white"
                                onClick={() => getHeaderById(`${head.id}`)}
                              >
                                <i
                                  className="fa fa-pencil"
                                  aria-hidden="true"
                                ></i>
                              </button>
                              {/* <a
                                onClick={() => deleteProduct(`${prd.id}`)}
                                className="px-3 py-1 bg-red-500 ml-2 text-white cursor-pointer"
                              >
                                <i
                                  className="fa fa-trash"
                                  aria-hidden="true"
                                ></i>
                              </a> */}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="w-[90vw]  md:w-[45vw] h-[300px] overflow-y-hidden overflow-x-auto  bg-white md:mt-2 mt-8 drop-shadow-lg p-4 rounded-xl mx-auto">
                <div className="flex justify-between border-b-2 pb-1 items-center">
                  <div>
                    <h3 className="uppercase text-lg text-slate-500">Kontak</h3>
                  </div>
                  {/* <button
                    className="hover:text-emerald-900"
                    onClick={() =>
                      document
                        .getElementById("tambah-kontak")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-plus-circle text-xl text-green-600"
                      aria-hidden="true"
                    ></i>
                  </button> */}
                </div>
                <div className="w-full h-full pb-8 overflow-auto">
                  <table className="table-auto w-full border-collapse mt-4">
                    <thead>
                      <tr className="text-sm">
                        <th className="border p-2">No</th>
                        <th className="border p-2 ">Nama</th>
                        <th className="border">Socmed</th>
                        <th className="border">No HP</th>
                        <th className="border">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {contact.map((ct, index) => (
                        <tr key={ct.id} className="text-center text-sm">
                          <td className="border p-2">{index + 1}</td>
                          <td className="border px-10">{ct.name}</td>
                          <td className="border px-10">{ct.socmed}</td>
                          <td className="border px-10">{ct.noHP}</td>
                          <td className="border">
                            <div className="flex px-2 justify-center">
                              <button
                                onClick={() =>
                                  // document
                                  //   .getElementById("ubah-admin")
                                  //   .classList.toggle("hidden")
                                  getContactById(`${ct.id}`)
                                }
                                className="px-3 py-1 bg-blue-600 text-white"
                              >
                                <i
                                  className="fa fa-pencil"
                                  aria-hidden="true"
                                ></i>
                              </button>
                              {/* <a
                                onClick={() => deleteContact(`${ct.id}`)}
                                className="px-3 py-1 bg-red-500 ml-2 text-white cursor-pointer"
                              >
                                <i
                                  className="fa fa-trash"
                                  aria-hidden="true"
                                ></i>
                              </a> */}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="w-[90vw]  md:w-[45vw] h-[300px] overflow-y-hidden overflow-x-auto  bg-white md:mt-2 mt-8 drop-shadow-lg p-4 rounded-xl mx-auto">
                <div className="flex justify-between border-b-2 pb-1 items-center">
                  <div>
                    <h3 className="uppercase text-lg text-slate-500">
                      File Download
                    </h3>
                  </div>
                  <button
                    className="hover:text-emerald-900"
                    onClick={() =>
                      document
                        .getElementById("tambah-download")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-plus-circle text-xl text-green-600"
                      aria-hidden="true"
                    ></i>
                  </button>
                </div>
                <div className="w-full h-full pb-8 overflow-auto">
                  <table className="table-auto w-full border-collapse mt-4">
                    <thead>
                      <tr className="text-sm">
                        <th className="border p-2">No</th>
                        <th className="border p-2 ">Nama</th>
                        <th className="border">Link</th>
                        <th className="border">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {download.map((dl, index) => (
                        <tr key={dl.id} className="text-center text-sm">
                          <td className="border p-2">{index + 1}</td>
                          <td className="border px-10">{dl.name}</td>
                          <td className="border px-10 text-[9px]">{dl.url}</td>

                          <td className="border">
                            <div className="flex px-2 justify-center">
                              <button
                                onClick={() =>
                                  // document
                                  //   .getElementById("ubah-admin")
                                  //   .classList.toggle("hidden")
                                  getDownloadById(`${dl.id}`)
                                }
                                className="px-3 py-1 bg-blue-600 text-white"
                              >
                                <i
                                  className="fa fa-pencil"
                                  aria-hidden="true"
                                ></i>
                              </button>
                              <a
                                onClick={() => deleteDownload(`${dl.id}`)}
                                className="px-3 py-1 bg-red-500 ml-2 text-white cursor-pointer"
                              >
                                <i
                                  className="fa fa-trash"
                                  aria-hidden="true"
                                ></i>
                              </a>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ========================== M O D A L =============================== */}
        {/* TAMBAH KATEGORI */}
        <div id="tambah-kategori" className="hidden w-full">
          <div className="w-full  bg-slate-800  top-0 flex justify-center fixed">
            <div className="absolute w-[90vw] md:max-w-[500px]  bg-gray-700 top-[30vh] drop-shadow-lg p-7 rounded-lg">
              <div className="w-full  pb-2">
                <h3 className="text-white text-xl font-medium flex justify-between ">
                  {" "}
                  Tambah Kategori
                  <button
                    className="hover:text-red-500 transition"
                    onClick={() =>
                      document
                        .getElementById("tambah-kategori")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-times-circle fa-lg"
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
              </div>
              <div className="mt-4">
                <form
                  className="space-y-6"
                  action="#"
                  onSubmit={createCategory}
                >
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Nama Kategori
                    </label>
                    <input
                      type="text"
                      name="text"
                      placeholder="Kaos"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      onChange={(e) => setCategoryName(e.target.value)}
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Tambah
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* UBAH KATEGORI */}
        <div id="ubah-kategori" className="hidden w-full">
          <div className="w-full  bg-slate-800  top-0 flex justify-center fixed">
            <div className="absolute w-[90vw] md:max-w-[500px]  bg-gray-700 top-[30vh] drop-shadow-lg p-7 rounded-lg">
              <div className="w-full  pb-2">
                <h3 className="text-white text-xl font-medium flex justify-between ">
                  {" "}
                  Ubah Kategori
                  <button
                    className="hover:text-red-500 transition"
                    onClick={() =>
                      document
                        .getElementById("ubah-kategori")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-times-circle fa-lg"
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
              </div>
              <div className="mt-4">
                <form className="space-y-6" onSubmit={updateCategory}>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Nama Kategori
                    </label>
                    <input
                      type="text"
                      name="text"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      value={categoryById}
                      onChange={(e) => setCategoryById(e.target.value)}
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Ubah
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* INTRO PEMBUKA */}
        {/* Ubah */}
        <div id="ubah-intro" className="hidden w-full">
          <div className="w-full  bg-slate-800  top-0 flex justify-center fixed">
            <div className="absolute w-[90vw] md:max-w-[500px]  bg-gray-700 top-[30vh] drop-shadow-lg p-7 rounded-lg">
              <div className="w-full  pb-2">
                <h3 className="text-white text-xl font-medium flex justify-between ">
                  {" "}
                  Ubah Teks Pembuka
                  <button
                    className="hover:text-red-500 transition"
                    onClick={() =>
                      document
                        .getElementById("ubah-intro")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-times-circle fa-lg"
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
              </div>
              <div className="mt-4">
                <form className="space-y-6" onSubmit={updateIntro}>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Teks Intro / Pembuka
                    </label>
                    <textarea
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      cols="10"
                      rows="2"
                      required
                      onChange={(e) => setIntroCaption(e.target.value)}
                      value={introCaption}
                    ></textarea>
                  </div>
                  <button
                    type="submit"
                    className="w-full mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Ubah
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Admin Modal */}
        {/* Tambah */}
        <div id="tambah-admin" className="hidden w-full">
          <div className="w-full  bg-slate-800  top-0 flex justify-center fixed">
            <div className="absolute w-[90vw] md:top-[20vh] md:max-w-[500px] bg-gray-700 top-[30vh] drop-shadow-lg p-7 rounded-lg">
              <div className="w-full  pb-2">
                <h3 className="text-white text-xl font-medium flex justify-between ">
                  {" "}
                  Tambah Admin
                  <button
                    className="hover:text-red-500 transition"
                    onClick={() =>
                      document
                        .getElementById("tambah-admin")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-times-circle fa-lg"
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
              </div>
              <div className="mt-4">
                <form className="space-y-6" onSubmit={createUser}>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Username
                    </label>
                    <input
                      type="text"
                      name="text"
                      id="nama"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Nama
                    </label>
                    <input
                      type="text"
                      name="text"
                      id="nama"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      value={userName}
                      onChange={(e) => setUserName(e.target.value)}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Password
                    </label>
                    <input
                      id="nama"
                      type="password"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Tambah
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* Ubah */}
        <div id="ubah-admin" className="hidden w-full">
          <div className="w-full  bg-slate-800  top-0 flex justify-center fixed">
            <div className="absolute w-[90vw] md:top-[20vh] md:max-w-[500px] bg-gray-700 top-[30vh] drop-shadow-lg p-7 rounded-lg">
              <div className="w-full  pb-2">
                <h3 className="text-white text-xl font-medium flex justify-between ">
                  {" "}
                  Ubah Admin
                  <button
                    className="hover:text-red-500 transition"
                    onClick={() =>
                      document
                        .getElementById("ubah-admin")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-times-circle fa-lg"
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
              </div>
              <div className="mt-4">
                <form className="space-y-6" onSubmit={updateUser}>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Username
                    </label>
                    <input
                      type="text"
                      name="text"
                      id="nama"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      readOnly
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Nama
                    </label>
                    <input
                      type="text"
                      name="text"
                      id="nama"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      value={userName}
                      onChange={(e) => setUserName(e.target.value)}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Pasword
                    </label>
                    <input
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Ubah
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Klien Modal */}
        {/* Tambah */}
        <div id="tambah-klien" className="hidden w-full">
          <div className="w-full  bg-slate-800  top-0 flex justify-center fixed">
            <div className="absolute w-[90vw] md:max-w-[500px]  bg-gray-700 top-[30vh] drop-shadow-lg p-7 rounded-lg">
              <div className="w-full  pb-2">
                <h3 className="text-white text-xl font-medium flex justify-between ">
                  {" "}
                  Tambah Klien
                  <button
                    className="hover:text-red-500 transition"
                    onClick={() =>
                      document
                        .getElementById("tambah-klien")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-times-circle fa-lg"
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
              </div>
              <div className="mt-4">
                <form className="space-y-6" onSubmit={createClient}>
                  <div>
                    <label
                      htmlFor="email"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Foto
                    </label>
                    <input
                      type="file"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      // value={clientPhoto}
                      onChange={(e) => setClientPhoto(e.target.files[0])}
                      required
                    />
                    <span className="text-red-500 text-sm italic mt-3 inline-block">
                      * Rekomendasi Ukuran Foto P. 95px x L. 50px
                    </span>
                  </div>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Nama Klien
                    </label>
                    <input
                      type="text"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      // value={clientName}
                      onChange={(e) => setClientName(e.target.value)}
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Tambah
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* Ubah */}
        <div id="ubah-klien" className="hidden w-full">
          <div className="w-full  bg-slate-800  top-0 flex justify-center fixed">
            <div className="absolute w-[90vw] md:max-w-[500px]  bg-gray-700 top-[30vh] drop-shadow-lg p-7 rounded-lg">
              <div className="w-full  pb-2">
                <h3 className="text-white text-xl font-medium flex justify-between ">
                  {" "}
                  Ubah Klien
                  <button
                    className="hover:text-red-500 transition"
                    onClick={() =>
                      document
                        .getElementById("ubah-klien")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-times-circle fa-lg"
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
              </div>
              <div className="mt-4">
                <form className="space-y-6" onSubmit={updateClient}>
                  <div>
                    <label
                      htmlFor="email"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Foto
                    </label>
                    <input
                      type="file"
                      name="email"
                      id="email"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      onChange={(e) => setClientPhoto(e.target.files[0])}
                    />
                    <span className="text-red-500 text-sm italic mt-3 inline-block">
                      * Rekomendasi Ukuran Foto P. 95px x L. 50px
                    </span>
                  </div>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Nama Klien
                    </label>
                    <input
                      type="text"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      value={clientName}
                      onChange={(e) => setClientName(e.target.value)}
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Ubah
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Servis Modal */}
        {/* Tambah */}
        <div id="tambah-servis" className="hidden w-full">
          <div className="w-full  bg-slate-800  top-0 flex justify-center fixed">
            <div className="absolute w-[90vw] md:max-w-[500px]  bg-gray-700 top-[30vh] md:top-[15vh] drop-shadow-lg p-7 rounded-lg">
              <div className="w-full  pb-2">
                <h3 className="text-white text-xl font-medium flex justify-between ">
                  {" "}
                  Tambah Servis
                  <button
                    className="hover:text-red-500 transition"
                    onClick={() =>
                      document
                        .getElementById("tambah-servis")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-times-circle fa-lg"
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
              </div>
              <div className="mt-4">
                <form className="space-y-6" onSubmit={createService}>
                  <div>
                    <label
                      htmlFor="email"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Foto
                    </label>
                    <input
                      type="file"
                      name="email"
                      id="email"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      onChange={(e) => setServicePhoto(e.target.files[0])}
                      required
                    />
                    <span className="text-red-500 text-sm italic mt-3 inline-block">
                      * Ukuran Foto harus P. 45px x L. 45px
                    </span>
                  </div>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Nama Servis
                    </label>
                    <input
                      type="text"
                      name="text"
                      id="nama"
                      placeholder="Terpercaya"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      onChange={(e) => setServiceName(e.target.value)}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Keterangan
                    </label>
                    <input
                      type="text"
                      name="text"
                      placeholder="Percayakan kepada kami"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      onChange={(e) => setServiceCaption(e.target.value)}
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Tambah
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* Ubah */}
        <div id="ubah-servis" className="hidden w-full">
          <div className="w-full  bg-slate-800  top-0 flex justify-center fixed">
            <div className="absolute w-[90vw] md:max-w-[500px]  bg-gray-700 top-[15vh] drop-shadow-lg p-7 rounded-lg">
              <div className="w-full  pb-2">
                <h3 className="text-white text-xl font-medium flex justify-between ">
                  {" "}
                  Ubah Servis
                  <button
                    className="hover:text-red-500 transition"
                    onClick={() =>
                      document
                        .getElementById("ubah-servis")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-times-circle fa-lg"
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
              </div>
              <div className="mt-4">
                <form className="space-y-6" onSubmit={updateService}>
                  <div>
                    <label
                      htmlFor="email"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Foto
                    </label>
                    <input
                      type="file"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      onChange={(e) => setServicePhoto(e.target.files[0])}
                    />
                    <span className="text-red-500 text-sm italic mt-3 inline-block">
                      * Ukuran Foto harus P. 45px x L. 45px
                    </span>
                  </div>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Nama Servis
                    </label>
                    <input
                      type="text"
                      name="text"
                      id="nama"
                      placeholder="Terpercaya"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      value={serviceName}
                      onChange={(e) => setServiceName(e.target.value)}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Keterangan
                    </label>
                    <input
                      type="text"
                      name="text"
                      id="keterangan"
                      placeholder="Percayakan kepada kami"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      value={serviceCaption}
                      onChange={(e) => setServiceCaption(e.target.value)}
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Ubah
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Tentang Kami Modal */}
        {/* Ubah */}
        <div id="ubah-tentang-kami" className="hidden w-full">
          <div className="w-full  bg-slate-800  top-0 flex justify-center fixed">
            <div className="absolute w-[90vw] md:max-w-[500px]  bg-gray-700 top-[30vh] drop-shadow-lg p-7 rounded-lg">
              <div className="w-full  pb-2">
                <h3 className="text-white text-xl font-medium flex justify-between ">
                  {" "}
                  Ubah Tentang Kami
                  <button
                    className="hover:text-red-500 transition"
                    onClick={() =>
                      document
                        .getElementById("ubah-tentang-kami")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-times-circle fa-lg"
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
              </div>
              <div className="mt-4">
                <form className="space-y-6" onSubmit={updateAbout}>
                  <div>
                    <label
                      htmlFor="email"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Logo
                    </label>
                    <input
                      type="file"
                      onChange={(e) => setAboutPhoto(e.target.files[0])}
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    />
                    <span className="text-red-500 text-sm italic mt-3 inline-block">
                      * Rekomendasi Ukuran Foto P. 100px x L. 60px / Disesuaikan
                    </span>
                  </div>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Keterangan
                    </label>
                    <textarea
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      cols="10"
                      rows="2"
                      value={aboutCaption}
                      onChange={(e) => setAboutCaption(e.target.value)}
                      required
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    className="w-full mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Ubah
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* CategoryDisplay Modal */}
        {/* Tambah */}
        <div id="tambah-display" className="hidden w-full">
          <div className="w-full  bg-slate-800  top-0 flex justify-center fixed">
            <div className="absolute w-[90vw] md:max-w-[500px]  bg-gray-700 top-[30vh] drop-shadow-lg p-7 rounded-lg">
              <div className="w-full  pb-2">
                <h3 className="text-white text-xl font-medium flex justify-between ">
                  {" "}
                  Tambah Display
                  <button
                    className="hover:text-red-500 transition"
                    onClick={() =>
                      document
                        .getElementById("tambah-display")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-times-circle fa-lg"
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
              </div>
              <div className="mt-4">
                <form className="space-y-6" onSubmit={createDisplay}>
                  <div>
                    <label
                      htmlFor="email"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Foto
                    </label>
                    <input
                      type="file"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      // value={clientPhoto}
                      onChange={(e) => setDisplayPhoto(e.target.files[0])}
                      required
                    />
                  </div>

                  <label
                    htmlFor="countries"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                  >
                    Kategori
                  </label>
                  <select
                    id="countries"
                    className="bbg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                    defaultValue="#"
                    onChange={(e) => setDisplayCategory(e.target.value)}
                  >
                    <option value="#">Pilih Kategori</option>
                    {category.map((ctgr, i) => (
                      <option key={ctgr.id} value={ctgr.id}>
                        {ctgr.name}
                      </option>
                    ))}
                  </select>

                  <button
                    type="submit"
                    className="w-full mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Tambah
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* Ubah */}
        <div id="ubah-display" className="hidden w-full">
          <div className="w-full  bg-slate-800  top-0 flex justify-center fixed">
            <div className="absolute w-[90vw] md:max-w-[500px]  bg-gray-700 top-[30vh] drop-shadow-lg p-7 rounded-lg">
              <div className="w-full  pb-2">
                <h3 className="text-white text-xl font-medium flex justify-between ">
                  {" "}
                  Ubah Display
                  <button
                    className="hover:text-red-500 transition"
                    onClick={() =>
                      document
                        .getElementById("ubah-display")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-times-circle fa-lg"
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
              </div>
              <div className="mt-4">
                <form className="space-y-6" onSubmit={updateDisplay}>
                  <div>
                    <label
                      htmlFor="email"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Foto
                    </label>
                    <input
                      type="file"
                      name="email"
                      id="email"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      onChange={(e) => setDisplayPhoto(e.target.files[0])}
                    />
                    <span className="text-red-500 text-sm italic mt-3 inline-block">
                      * Untuk Ukuran Display Persegi P. 675px x L. 675px <br />*
                      Untuk Ukuran Display Persegi Panjang P. 675px x L. 337px
                    </span>
                  </div>
                  <div>
                    <label
                      htmlFor="countries"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Kategori
                    </label>
                    <select
                      className="bbg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      value={displayCategory}
                      onChange={(e) => setDisplayCategory(e.target.value)}
                    >
                      <option value="#">Pilih Kategori</option>
                      {category.map((ctgr, i) => (
                        <option key={ctgr.id} value={ctgr.id}>
                          {ctgr.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <button
                    type="submit"
                    className="w-full mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Ubah
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Produk Modal */}
        {/* Tambah */}
        <div id="tambah-produk" className="hidden w-full">
          <div className="w-full  bg-slate-800  top-0 flex justify-center fixed">
            <div className="absolute w-[90vw] md:max-w-[500px]  bg-gray-700 top-[30vh] md:top-[20vh] drop-shadow-lg p-7 rounded-lg">
              <div className="w-full  pb-2">
                <h3 className="text-white text-xl font-medium flex justify-between ">
                  {" "}
                  Tambah Produk
                  <button
                    className="hover:text-red-500 transition"
                    onClick={() =>
                      document
                        .getElementById("tambah-produk")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-times-circle fa-lg"
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
              </div>
              <div className="mt-4">
                <form className="space-y-6" onSubmit={createProduct}>
                  <div>
                    <label
                      htmlFor="email"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Foto
                    </label>
                    <input
                      type="file"
                      name="email"
                      id="email"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      onChange={(e) => setProductPhoto(e.target.files[0])}
                      required
                    />
                    <span className="text-red-500 text-sm italic mt-3 inline-block">
                      * Ukuran Foto harus P. 225px x L. 225px
                    </span>
                  </div>
                  <div>
                    <label
                      htmlFor="countries"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Kategori
                    </label>
                    <select
                      id="countries"
                      className="bbg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      defaultValue="#"
                      onChange={(e) => setProductCategory(e.target.value)}
                    >
                      <option value="#">Pilih Kategori</option>
                      {category.map((ctgr, i) => (
                        <option key={ctgr.id} value={ctgr.id}>
                          {ctgr.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Nama
                    </label>
                    <input
                      type="text"
                      placeholder="Kaos"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      onChange={(e) => setProductName(e.target.value)}
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Tambah
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* Ubah */}
        <div id="ubah-produk" className="hidden w-full">
          <div className="w-full  bg-slate-800  top-0 flex justify-center fixed">
            <div className="absolute w-[90vw] md:max-w-[500px]  bg-gray-700 top-[30vh] md:top-[20vh] drop-shadow-lg p-7 rounded-lg">
              <div className="w-full  pb-2">
                <h3 className="text-white text-xl font-medium flex justify-between ">
                  {" "}
                  Ubah Produk
                  <button
                    className="hover:text-red-500 transition"
                    onClick={() =>
                      document
                        .getElementById("ubah-produk")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-times-circle fa-lg"
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
              </div>
              <div className="mt-4">
                <form className="space-y-6" onSubmit={updateProduct}>
                  <div>
                    <label
                      htmlFor="email"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Foto
                    </label>
                    <input
                      type="file"
                      name="email"
                      id="email"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      onChange={(e) => setProductPhoto(e.target.files[0])}
                    />
                    <span className="text-red-500 text-sm italic mt-3 inline-block">
                      * Ukuran Foto harus P. 225px x L. 225px
                    </span>
                  </div>
                  <div>
                    <label
                      htmlFor="countries"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Kategori
                    </label>
                    <select
                      id="countries"
                      className="bbg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      value={productCategory}
                      onChange={(e) => setProductCategory(e.target.value)}
                    >
                      <option value="#">Pilih Kategori</option>
                      {category.map((ctgr, i) => (
                        <option key={ctgr.id} value={ctgr.id}>
                          {ctgr.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Nama
                    </label>
                    <input
                      type="text"
                      placeholder="Kaos"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      value={productName}
                      onChange={(e) => setProductName(e.target.value)}
                    />
                  </div>
                  <button
                    type="submit"
                    className="w-full mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Ubah
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Kontak Modal */}
        {/* Tambah */}
        <div id="tambah-kontak" className="hidden w-full">
          <div className="w-full  bg-slate-800  top-0 flex justify-center fixed">
            <div className="absolute w-[90vw] md:top-[20vh] md:max-w-[500px] bg-gray-700 top-[30vh] drop-shadow-lg p-7 rounded-lg">
              <div className="w-full  pb-2">
                <h3 className="text-white text-xl font-medium flex justify-between ">
                  {" "}
                  Tambah Kontak
                  <button
                    className="hover:text-red-500 transition"
                    onClick={() =>
                      document
                        .getElementById("tambah-kontak")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-times-circle fa-lg"
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
              </div>
              <div className="mt-4">
                <form className="space-y-6" onSubmit={createContact}>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Nama
                    </label>
                    <input
                      type="text"
                      name="text"
                      id="nama"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      onChange={(e) => setContactName(e.target.value)}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Sosial Media
                    </label>
                    <input
                      type="text"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      onChange={(e) => setContactSocmed(e.target.value)}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      No Handphone
                    </label>
                    <input
                      type="text"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      onChange={(e) => setContactNoHp(e.target.value)}
                    />
                  </div>

                  <button
                    type="submit"
                    className="w-full mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Tambah
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* Ubah */}
        <div id="ubah-kontak" className="hidden w-full">
          <div className="w-full  bg-slate-800  top-0 flex justify-center fixed">
            <div className="absolute w-[90vw] md:top-[20vh] md:max-w-[500px] bg-gray-700 top-[30vh] drop-shadow-lg p-7 rounded-lg">
              <div className="w-full  pb-2">
                <h3 className="text-white text-xl font-medium flex justify-between ">
                  {" "}
                  Ubah Kontak
                  <button
                    className="hover:text-red-500 transition"
                    onClick={() =>
                      document
                        .getElementById("ubah-kontak")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-times-circle fa-lg"
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
              </div>
              <div className="mt-4">
                <form className="space-y-6" onSubmit={updateContact}>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Nama
                    </label>
                    <input
                      type="text"
                      name="text"
                      id="nama"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      value={contactName}
                      onChange={(e) => setContactName(e.target.value)}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Sosial Media
                    </label>
                    <input
                      type="text"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      value={contactSocmed}
                      onChange={(e) => setContactSocmed(e.target.value)}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      No Handphone
                    </label>
                    <input
                      type="text"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      value={contactNoHp}
                      onChange={(e) => setContactNoHp(e.target.value)}
                    />
                  </div>

                  <button
                    type="submit"
                    className="w-full mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Ubah
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Header Modal */}
        {/* Ubah */}
        <div id="ubah-header" className="hidden w-full">
          <div className="w-full  bg-slate-800  top-0 flex justify-center fixed">
            <div className="absolute w-[90vw] md:max-w-[500px]  bg-gray-700 top-[30vh] md:top-[20vh] drop-shadow-lg p-7 rounded-lg">
              <div className="w-full  pb-2">
                <h3 className="text-white text-xl font-medium flex justify-between ">
                  {" "}
                  Ubah Header
                  <button
                    className="hover:text-red-500 transition"
                    onClick={() =>
                      document
                        .getElementById("ubah-header")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-times-circle fa-lg"
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
              </div>
              <div className="mt-4">
                <form className="space-y-6" onSubmit={updateHeader}>
                  <div>
                    <label
                      htmlFor="email"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Foto
                    </label>
                    <input
                      type="file"
                      name="email"
                      id="email"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      onChange={(e) => setHeaderPhoto(e.target.files[0])}
                      required
                    />
                    <span className="text-red-500 text-sm italic mt-3 inline-block">
                      * Rekomendasi Ukuran Foto P. 640px x L. 600px
                    </span>
                  </div>

                  <button
                    type="submit"
                    className="w-full mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Ubah
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Download Modal */}
        {/* Tambah */}
        <div id="tambah-download" className="hidden w-full">
          <div className="w-full  bg-slate-800  top-0 flex justify-center fixed">
            <div className="absolute w-[90vw] md:top-[20vh] md:max-w-[500px] bg-gray-700 top-[30vh] drop-shadow-lg p-7 rounded-lg">
              <div className="w-full  pb-2">
                <h3 className="text-white text-xl font-medium flex justify-between ">
                  {" "}
                  Tambah Download
                  <button
                    className="hover:text-red-500 transition"
                    onClick={() =>
                      document
                        .getElementById("tambah-download")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-times-circle fa-lg"
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
              </div>
              <div className="mt-4">
                <form className="space-y-6" onSubmit={createDownload}>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Nama
                    </label>
                    <input
                      type="text"
                      name="text"
                      id="nama"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      onChange={(e) => setDownloadName(e.target.value)}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Link Download
                    </label>
                    <input
                      type="text"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      onChange={(e) => setDownloadUrl(e.target.value)}
                    />
                  </div>

                  <button
                    type="submit"
                    className="w-full mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Tambah
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* Ubah */}
        <div id="ubah-download" className="hidden w-full">
          <div className="w-full  bg-slate-800  top-0 flex justify-center fixed">
            <div className="absolute w-[90vw] md:top-[20vh] md:max-w-[500px] bg-gray-700 top-[30vh] drop-shadow-lg p-7 rounded-lg">
              <div className="w-full  pb-2">
                <h3 className="text-white text-xl font-medium flex justify-between ">
                  {" "}
                  Ubah Download
                  <button
                    className="hover:text-red-500 transition"
                    onClick={() =>
                      document
                        .getElementById("ubah-download")
                        .classList.toggle("hidden")
                    }
                  >
                    <i
                      className="fa fa-times-circle fa-lg"
                      aria-hidden="true"
                    ></i>
                  </button>
                </h3>
              </div>
              <div className="mt-4">
                <form className="space-y-6" onSubmit={updateDownload}>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Nama
                    </label>
                    <input
                      type="text"
                      name="text"
                      id="nama"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      value={downloadName}
                      onChange={(e) => setDownloadName(e.target.value)}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="text"
                      className="block mb-2 text-sm font-medium text-white"
                    >
                      Link Download
                    </label>
                    <input
                      type="text"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                      required
                      value={downloadUrl}
                      onChange={(e) => setDownloadUrl(e.target.value)}
                    />
                  </div>

                  <button
                    type="submit"
                    className="w-full mt-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Tambah
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* <Modal categoryById={categoryById} /> */}
      </div>
    </>
  );
};

export default Dashboard;
